import React from 'react'
import PropTypes from 'prop-types'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import './PageLayout.scss'
import Header from '../skin/header/header.js'
import Footer from '../skin/footer/footer.js'
import skinToggle from '../../util/skinToggle.js'
import walmartTheme from '../../styles/themes/walmart/walmart.js'
import samsTheme from '../../styles/themes/samsclub/sams.js'
import walmartOnlineTheme from '../../styles/themes/walmartonline/wmonline.js'

// Toggle User Interface Themes for the entire Redd App based on the business domain - Walmart, Samsclub, etc
const muiTheme = toggleThemes()

//    ---- Function Definition ---
function toggleThemes () {
  let skinQueryParam = window.location.href.toLowerCase().match(/skin=([^&]*)/i)
  let skin = skinToggle.getSkin(skinQueryParam && skinQueryParam[1])

  if (skin === 'walmart') {
    return includeWalmartTheme()
  } else if (skin === 'sams') {
    return includeSamsTheme()
  } else if (skin === 'walmartonline') {
    return includeWalmartOnlineTheme()    
  } else {
      // default skin is samsclub
    return includeSamsTheme()
  }
}

function includeWalmartTheme () {
  return getMuiTheme(walmartTheme)
}

function includeWalmartOnlineTheme () {
  return getMuiTheme(walmartOnlineTheme)
}

function includeSamsTheme () {
  return getMuiTheme(samsTheme)
}

export const PageLayout = ({ children }) => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <div className='page-container'>
      <div className='page-content-container'>
        <div style={{ 'display': 'block' }}>
          <Header />
        </div>
        <div className='warp-page'>
          {children}
        </div>
        <div style={{ 'display': 'block' }}>
          <Footer />
        </div>
      </div>
    </div>
  </MuiThemeProvider>
)

PageLayout.propTypes = {
  children: PropTypes.node,
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js